/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { SVGIcons } from "cms/icons/svg-icons";

const AddItemButton = (props) => {

    const { t } = useTranslation();
    const buttonText = props?.buttonText;
    const addListItem = props?.addListItem;

    return (
        <Button
            className='add-button'
            variant='contained'
            onClick={addListItem}
        >
            <SVGIcons.common.Create />
            {buttonText || t("commons.addText")}
        </Button>
    );
};

AddItemButton.displayName = "AddItemButton";
export { AddItemButton };
